import React from 'react';
import { CheckCircle2, Circle } from 'lucide-react';
import { PASSWORD_RULES } from '../utils/passwordPolicy';

// Live checklist of the password policy for the password being typed.
const PasswordRequirements = ({ password }) => (
  <div
    aria-live="polite"
    style={{ backgroundColor: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: '0.6rem', padding: '0.75rem 0.9rem', marginBottom: '1.1rem' }}
  >
    <div style={{ fontSize: '0.8rem', fontWeight: 600, color: '#374151', marginBottom: '0.4rem' }}>Password requirements</div>
    <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
      {PASSWORD_RULES.map((rule) => {
        const met = rule.test(password || '');
        return (
          <li key={rule.key} style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.8rem', color: met ? '#15803d' : '#6b7280', padding: '0.1rem 0' }}>
            {met ? <CheckCircle2 size={14} aria-hidden="true" /> : <Circle size={14} aria-hidden="true" />}
            <span>{rule.label}</span>
            <span style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)' }}>
              {met ? '(met)' : '(not met)'}
            </span>
          </li>
        );
      })}
    </ul>
  </div>
);

export default PasswordRequirements;
